import React from 'react';
import { TextField, InputLabel } from '@material-ui/core';
import { useField } from 'formik';

const FormBasicSelect = ({
  name,
  options,
  label,
  initialOptText = 'Seçiniz...',
  ...otherProps
}) => {
  const [field, meta] = useField(name);

  const configSelect = {
    ...field,
    ...otherProps,
    name,
    select: true,
    size: 'small',
    variant: 'outlined',
    fullWidth: true,
    FormHelperTextProps: {
      className: 'mx-4 mt-2 text-12'
    },
    SelectProps: {
      displayEmpty: true,
      native: true
    }
  };

  if (meta && meta.touched && meta.error) {
    configSelect.error = true;
    configSelect.helperText = meta.error;
  }

  return (
    <>
      <InputLabel className="mb-8 text-gray-700 font-semibold">{label}</InputLabel>
      <TextField {...configSelect}>
        <option value="">{initialOptText}</option>
        {options.map(item => {
          return (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          );
        })}
      </TextField>
    </>
  );
};

export default FormBasicSelect;
